import { ITEMIZATION_WIDGET_ACTION } from "../../actions/itemizationWidgetActions";
import { createDummyDataHomeItemizationWidget } from '../../helpers/noDataHelper';

const itemizationWidgetDataReducer = (state = null, action) => {  
    switch (action.type) {
      case ITEMIZATION_WIDGET_ACTION.FETCH_DATA_SUCCESS: {
        state = {
          ...state,
          data: action.payload.data.itemizationDetails ? action.payload.data : createDummyDataHomeItemizationWidget(action.payload.translations),
          failed: !action.payload.data.itemizationDetails
        };
        break;
      }
      case ITEMIZATION_WIDGET_ACTION.FETCH_DATA_FAILED: {
        state = {
          ...state,
          failed: true,
          data: createDummyDataHomeItemizationWidget(action.payload.translations)
        };
        break;
      }
      case ITEMIZATION_WIDGET_ACTION.RESET_DATA:
        state = null;
        break;
      default:
        break;
    }    
  return state;
}

  export default itemizationWidgetDataReducer;
